module.exports = __webpack_public_path__ + "img/power.8ee08538.png";